import React from "react";

const Monetization = ({
  style = {},
  width = 20,
  height = 20,
  className = "",
  color = "#707070",
  textColor = "#fff",
  viewBox = "0 0 24 24",
  ...rest
}) => (
  <svg height={height} width={width} viewBox={viewBox} {...rest}>
    <g fill="none" fillRule="evenodd">
      <path d="M-4-2h27v28H-4z" />
      <path
        d="M12.41 1.02C12 .6 11.42.34 10.81.33H2.76A2.3 2.3 0 0 0 .5 2.67v18.66a2.23 2.23 0 0 0 2.25 2.34h13.5a2.3 2.3 0 0 0 2.25-2.34V8.3c0-.61-.23-1.2-.66-1.64L12.4 1.02zm-1.79 6.31V2.09l6.2 6.42h-5.07a1.13 1.13 0 0 1-1.13-1.18z"
        fill={color}
        fillRule="nonzero"
      />
      <path
        d="M9.24 13.83c-1.34-.36-1.77-.73-1.77-1.32 0-.58.6-1.13 1.6-1.13.99 0 1.43.52 1.46 1.29h1.3a2.4 2.4 0 0 0-1.88-2.33V9h-1.8v1.32a2.35 2.35 0 0 0-2.05 2.21c0 1.4 1.12 2.13 2.78 2.52 1.47.36 1.76.9 1.76 1.47s-.28 1.07-1.59 1.07c-1.3 0-1.7-.57-1.76-1.3H6a2.52 2.52 0 0 0 2.16 2.38V20h1.79v-1.33c1.15-.23 2.05-.93 2.05-2.13.01-1.75-1.43-2.35-2.76-2.71z"
        fill={textColor}
      />
    </g>
  </svg>
);

export default Monetization;
